import React, { useState, useEffect } from 'react'
import { curry, filter } from 'ramda'
import { StyledSearch, StyledSearchInput, StyledButtonClose, StyledSearchResults, StyledSearchResultsTitle, StyledSearchResultsList, StyledSearchHint, StyledSearchHintIcon, StyledSearchHintText } from './styled'
import Input from '../../components/inputs/FromInputFocus'
import ListItem from '../../components/ListItem';
import Container from '../../components/Container'
import { ListWrap, ListTitle, ListTags, ListContainer } from '../../components/ListItem/styled'

const SearchTag = React.memo(({ data: searchData, onClickTag, translation }) => {
  const [open, setOpen] = useState(false);
  const [searchId, setSearchId] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [isHint, setIsHint] = useState(false);

  const search = curry((id, data) => filter(d => d.tag_id.toString().slice(0, id.trim().length) === id.trim() || (d.cow_no !== null && d.cow_no.toString().slice(0, id.trim().length) === id.trim()), data));

  useEffect(() => {
    setFilteredData(search(searchId, searchData));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchData, searchId]);

  useEffect(() => {
    if (searchId.length > 0 && filteredData.length > 5) {
      setIsHint(true);
    } else {
      setIsHint(false);
    }
  }, [filteredData, searchId])

  const handleChangeSearch = e => setSearchId(e.target.value);

  const handleFocusSearch = () => {
    setOpen(true);
  }

  const handleBlurSearch = () => {
    if (searchId.length === 0) {
      setOpen(false);
    }
  }

  const handleCloseSearch = () => {
    setOpen(false);
    setSearchId("");
  }

  return (
    <StyledSearch>
      <Container>
        <StyledSearchInput>
          <Input
            type="number"
            placeholder={translation && translation.labels.placeholder1}
            placeholderFocused={translation && translation.labels.placeholder2}
            name="search"
            onChange={handleChangeSearch}
            onFocus={handleFocusSearch}
            onBlur={handleBlurSearch}
            value={searchId}
            icon={searchId.length > 0 ? '' : 'loupe'}
            fullWidth
            marginVertical
          />
          {
            open &&
            <StyledButtonClose
              transparent
              onClick={handleCloseSearch}
            >
              {translation && translation.buttons.close}
            </StyledButtonClose>
          }
        </StyledSearchInput>
        {
          isHint &&
          <StyledSearchHint>
            <StyledSearchHintIcon name='tooltip' />
            <StyledSearchHintText>{translation && translation.labels.hint}</StyledSearchHintText>
          </StyledSearchHint>
        }
      </Container>
      <StyledSearchResults>
        <StyledSearchResultsTitle>{translation && translation.labels.title}</StyledSearchResultsTitle>
        <StyledSearchResultsList>
          {
            filteredData &&
            filteredData.map(tag => (
              <ListItem
                key={tag.tag_id}
                arrow={false}
                onClick={onClickTag(tag.tag_id)}
              >
                <ListContainer>
                  <ListWrap>
                    <ListTitle>
                      {tag.headline}
                    </ListTitle>
                  </ListWrap>
                  <ListWrap>
                    <ListTags bold>
                      {tag.info}
                    </ListTags>
                  </ListWrap>
                </ListContainer>
              </ListItem>
            ))
          }
        </StyledSearchResultsList>
      </StyledSearchResults>
    </StyledSearch>
  )
});

SearchTag.defaultProps = {
  translation: {
    labels: {},
    buttons: {}
  }
}

export default SearchTag;